import { Tag, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined, DragOutlined } from "@ant-design/icons";

import { Sheet } from "./TemplateCreate.styles";
import { Flex } from "../../../../shared/base-components/Layouts/Flex/Flex.styles";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ThemePalette } from "../../../../theme";
import { useNavigate } from "react-router-dom";

export const SheetInfo = ({ data }: any) => {
  const navigate = useNavigate();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: data.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging ? { position: "relative", zIndex: 9999 } : {}),
  };
  return (
    <div className="column-container">
      <Sheet
        style={style}
        className={isDragging ? "dragging column" : "column"}
      >
        <Flex flexDirection="column" alignItems="flex-start" gap="12px">
          <Flex width="300px" alignItems="center">
            <h4>{data.sheetName}</h4>
            <Flex gap="12px">
              <Tooltip title="Edit">
                <EditOutlined
                  onClick={() => navigate("/template/1/sheet/1")}
                  style={{ color: ThemePalette.colorPrimaryLight }}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteOutlined style={{ color: "#ef4444" }} />
              </Tooltip>
              <Tooltip title="Drag to reorder">
                <DragOutlined
                  ref={setNodeRef}
                  {...attributes}
                  {...listeners}
                  className="grab"
                />
              </Tooltip>
            </Flex>
          </Flex>
          {data.dependency ? (
            <div>
              <h3>Dependencies</h3>
              <Flex flexWrap="wrap" gap="4px" justifyContent="none">
                {data.dependency
                  .split(",")
                  .map((dep: any, i: number) => (
                    <Tag key={i}>{dep}</Tag>
                  ))}
              </Flex>
            </div>
          ) : (
            <h3>No Dependencies</h3>
          )}
        </Flex>
      </Sheet>
    </div>
  );
};
